import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./state/index";
import { BrowserRouter as Router } from "react-router-dom";
import TourProvider from "./components/tutorial/TourProvider";
import TranslationProvider from "./i18n/TranslationProvider";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
        <Router>
          <TranslationProvider>
            <TourProvider>
              <App />
            </TourProvider>
          </TranslationProvider>
        </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
